<template>
  <div>
    <main>
      <div class="WorkM_MainArea">
        <b-container fluid style="max-width: 700px">
          <!-- 日付 -->
          <div class="WorkRegist_DispDateArea position-relative">
            <div>
              {{ dispDate }} ({{ dispDayOfWeek }}) {{ dateType }}
              <b-button size="sm" variant="transparent" to="/manager/WorkCalendar" class="workCalendarIcon" >
                <b-icon icon="calendar3" variant="primary"></b-icon>
              </b-button>
            </div>
          </div>
          <!-- シフト -->
          <div class="DispShiftArea">
            <div>シフト {{ shiftStart }} - {{ shiftEnd }}</div>
          </div>
          <!-- 報告 -->
          <div class="WorkM_Card_ContentArea">
            <div>
              <div v-if="showCopyBtn() && !isViewOnly && !isOutsideTerm && !isTransferSalary && isDateTypeWeekday(dateTypeCode)" class="d-flex flex-row-reverse mt-3">
                <div class="WorkM_Button WorkM_AddButton WorkM_PreCopyButton m-0" @click="clickPreDateCopy()" :class="{'WorkM_AddButton_Disabled':isErrorGetShfitFlg}">
                  前日コピー
                </div>
              </div>
              <div v-if="!isViewOnly && !isOutsideTerm && !isTransferSalary" class="mt-3">
                <div class="WorkM_Button WorkM_AddButton" @click="clickNewWorkItem(1)" :class="{'WorkM_AddButton_Disabled': isErrorGetShfitFlg}">
                  <b-icon icon="plus-lg" class="mr-2"></b-icon>追加
                </div>
              </div>
              <div v-for="workInfoItem in todayWorkInfo" :key="workInfoItem.ditailNo">
                <div class="WorkInfoItem my-2" :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'text-danger' : ''" @click="clickUpdateWorkItem(workInfoItem)">
                  <!-- 時間 -->
                  <div
                    class="WorkInfoItem_WorkTimeArea"
                    :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'WorkInfoItem_WorkTimeArea_Red' : ''"
                    style="justify-content:center"
                  >
                    <div>{{ workInfoItem.startTime }}</div>
                    <div><b-icon icon="dash-lg" rotate="90" scale="0.8"></b-icon></div>
                    <div>{{ workInfoItem.endTime }}</div>
                  </div>
                  <!-- 内容 -->
                  <div class="WorkInfoItem_WorkContentArea">
                    <div class="WorkContent_ItemTypeArea" style="display: flex; flex-wrap:wrap;">
                      <div
                        class="WorkContent_ItemTypeArea_TypeLabel"
                        :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'WorkContent_ItemTypeArea_TypeLabel_Red' : ''"
                      >
                        {{ getDispSegment(workInfoItem.workSegment) }}
                      </div>
                      <div v-if="workInfoItem.disasterKbn == 1" class="text-danger ml-2">災害</div>
                    </div>
                    <div class="mt-1">
                      <div v-if="isAttendanceCheck(workInfoItem.workSegment) && workInfoItem.constructionCode !== '0'" class="WorkContent_ItemNote" style="height: auto;">
                        <div v-if="workInfoItem.constructionCode !== '0'" class="WorkContent_ConstructionCode">[{{ workInfoItem.constructionCode }}]</div>
                        <div v-if="workInfoItem.constructionName !== null" class="WorkContent_ConstructionName">{{ workInfoItem.constructionName }}</div>
                      </div>
                      <div>
                        <div class="WorkRegist_DispMemoArea" v-html="setLineFeedCode(workInfoItem.itemNote)"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!showCopyBtn() && !isViewOnly && !isOutsideTerm && !isTransferSalary">
                <div class="WorkM_Button WorkM_AddButton" @click="clickNewWorkItem(2)" :class="{'WorkM_AddButton_Disabled': isErrorGetShfitFlg}">
                  <b-icon icon="plus-lg" class="mr-2"></b-icon>追加
                </div>
              </div>
              <div v-if="this.isNeedWorkApproval && isViewOnly" class="d-flex"  style="align-items: center; justify-content: flex-end" >
                <div class="d-flex flex-row" style="margin-top: 6px; margin-bottom: 6px; font-size: 1rem; width: 95px;">
                  <div v-if="this.workApprovalKbn == 3" class="ApprovalLabel" style="width: 100%;">
                    <div class="WorkContent_ItemTypeArea_TypeLabel text-center ApprovalIcon_Label mx-auto px-0">承認</div>
                  </div>
                  <div v-else-if="isViewOnly" class="RejectionLabel" style="width: 100%;">
                    <div class="WorkContent_ItemTypeArea_TypeLabel text-center PendingIcon_Label px-0">承認待ち</div>
                  </div>
                </div>
                <div><div>({{ this.approvalShainName }})</div></div>
              </div>
              <div v-else-if="this.isNeedWorkApproval && this.workApprovalKbn == 4" class="d-flex"  style="align-items: center; justify-content: flex-end" >
                <div class="d-flex flex-row" style="margin-top: 6px; margin-bottom: 6px; font-size: 1rem; width: 95px;">
                  <div class="RejectionLabel" style="width: 100%;">
                    <div class="WorkContent_ItemTypeArea_TypeLabel text-center RejectionIcon_Label mx-auto px-0">否認</div>
                  </div>
                </div>
                <div><div>({{ this.approvalShainName }})</div></div>
              </div>
            </div>
            <!-- ボタン -->
            <div class="mt-5" v-if="!showCopyBtn() && !isViewOnly && !isOutsideTerm && !isTransferSalary">
              <!-- 
              対象日付の報告データが何かしら登録されている、
              かつ未確定、かつ当月の範囲内、かつ給与システム転送前なら
              確定ボタンを表示
              -->
              <div class="WorkM_WorkRegistButtonArea mt-3">
                <button v-bind:disabled="isNotValidRegistBtn()" type="button" class="WorkM_Button btn btn-success px-5" @click="sendWorkMail()">確定</button>
              </div>
            </div>
            <div class="mt-5" v-else>
              <!--
              確定済、かつ当月の範囲内、かつ給与システム転送前なら、確定解除ボタンを表示
              -->
              <div v-if="isViewOnly && !isOutsideTerm && !isTransferSalary">
                <div class="WorkM_WorkRegistButtonArea mt-3">
                  <button type="button" class="WorkM_Button btn btn-secondary px-5" @click="clickCancelConfirm()">確定解除</button>
                </div>
              </div>
              <!--
              確定済、または当月の開始日より前、または給与システム転送済なら、
              確定済ボタンを表示し、変更は不可
              -->
              <div v-else-if="isViewOnly || isOutsideTerm || isTransferSalary">
                <div class="WorkM_WorkRegistButtonArea mt-3">
                  <button type="button" class="WorkM_Button btn btn-secondary px-5 WorkM_Button_Confirm" disabled>確定済</button>
                </div>
              </div>
            </div>
            <!--上記のいずれでもない場合、何も表示しない-->
          </div>
        </b-container>
      </div>
    </main>
    <WorkEditModalVue 
      ref="WorkEditModal"
      :title="workEditModalTitle"
      :addType="addType"
      :workDate="workDate"
      :dateType="dateTypeCode"
      :userId="userId"
      :workSegment="workSegment"
      :detailNo="detailNo"
      :startTime="startTime"
      :endTime="endTime"
      :constructionCode="constructionCode"
      :constructionName="constructionName"
      :itemNote="itemNote"
      :disasterKbn="disasterKbn"
      :approvalKbn="approvalKbn"
      :shiftStart="shiftStart"
      :shiftEnd="shiftEnd"
      @getWorkRegistInfo="getWorkRegistInfo"
      >
    </WorkEditModalVue>
  </div>
</template>

<script>
import WorkEditModalVue from "../../components/Modal/WorkEditModal.vue";
import config from "../../const/config";

export default {
  name: "WorkRegist",
  components: { WorkEditModalVue },
  data() {
    return {
      systemVersion: null,
      dispDate: null,
      dispDayOfWeek: null,
      todayWorkInfo: null,
      loginUserId: null,
      targetDate: null,
      isViewOnly: false, // 確定済みフラグ
      isOutsideTerm: false, // 当月範囲内フラグ
      isTransferSalary: false, // 給与システム転送フラグ
      submittedFlag: null,
      items: null,
      dateType: "",
      dateTypeCode: 0,
      shiftStart: "",
      shiftEnd: "",
      afterStart: "",
      beforeEnd: "",
      workDate: "",
      userId: "",
      workSegment: 0,
      detailNo: 0,
      startTime: "",
      endTime: "",
      constructionCode: "",
      constructionName: "",
      itemNote: "",
      disasterKbn: 0,
      approvalKbn: 0,
      addType: 0,
      workEditModalTitle: "",
      isErrorGetShfitFlg: true,
      isNeedWorkApproval: false,
      workApprovalKbn: 0,
      approvalShainName: "",
    };
  },
  computed: {
    
  },

  watch: {
    workApprovalKbn(){
      this.isNotValidRegistBtn();
    }
  },
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
    // 月間画面から遷移してきたか確認
    if(this.$store.state.is_from_work_calendar){
      this.targetDate = this.$store.state.target_date;
      let isFromWorkCalendar = {
        is_from_work_calendar: false,
      };
      this.$store.commit("setIsFromWorkCalendar", isFromWorkCalendar);
    }
    else{
      this.targetDate = null;
    }
    console.debug("targetDate：" + this.targetDate);
    this.dispDate = this.targetDate;
    this.getWorkRegistInfo();
  },

  methods: {
    // 前日コピーボタン表示するかチェックする
    // true:前日コピーボタンを表示する
    // false:下追加ボタン、確定系ボタンを表示する
    showCopyBtn: function(){
      return (this.todayWorkInfo == null || Object.keys(this.todayWorkInfo).length == 0);
    },
    // 追加ボタンを押した際の動作、報告登録ポップアップを表示する
    clickNewWorkItem: function (clickType) {
      if(this.isErrorGetShfitFlg){
        return;
      }
      this.workEditModalTitle = "報告登録"
      this.workDate = this.dispDate;
      this.userId = this.loginUserId;
      this.workSegment = 0;
      this.detailNo = 0;
      this.constructionCode = null;
      this.constructionName = null;
      this.itemNote = null;
      this.disasterKbn = 0;
      this.approvalKbn = 0;
      this.addType = clickType;
      this.setTime();
      this.openWorkEditModal();
    },
    // 報告登録ポップアップに初期表示する時間をセットする
    setTime :function(){
      // 時間情報のセット
      console.debug("addType：" + this.addType);
      // 日報情報が1件も登録されていないとき
      if(this.showCopyBtn()){
        this.startTime = this.shiftStart;
        this.endTime = this.shiftEnd;
      }
      else if(this.addType == 1){
        this.endTime = this.afterStart;
        // シフト開始時間と直後の開始時間が重なるとき、fromには何も入れない
        if(this.shiftStart >= this.afterStart){
          this.startTime = "0:00";
        }
        else{
          this.startTime = this.shiftStart;
        }
      }
      // addType = 2の場合、fromに直前の終了時間を、toにシフト終了時間を入れる
      else if(this.addType == 2){
      this.startTime = this.beforeEnd;
      // 直前の終了時間とシフト終了時間が重なるとき、toには何も入れない
        if(this.beforeEnd >= this.shiftEnd){
          this.endTime = "24:00";
        }
        else{
          this.endTime = this.shiftEnd;
        }
      }
    },
    // 明細行をタップした際の動作、報告更新ポップアップを表示する
    clickUpdateWorkItem: function(items){
      this.workEditModalTitle = "報告編集"
      this.workDate = items.workDate;
      this.userId = items.shainCd;
      this.workSegment = items.workSegment;
      this.detailNo = items.detailNo;
      this.startTime = items.startTime;
      this.endTime = items.endTime;
      this.constructionCode = items.constructionCode;
      this.constructionName = items.constructionName;
      this.itemNote = items.itemNote;
      this.disasterKbn = items.disasterKbn;
      this.approvalKbn = items.approvalKbnKbn;
      this.addType = 0;
      this.openWorkEditModal();
    },
    // 確定済みならポップアップを開かない
    // TODO: 変更。確定していても詳細ポップアップを開けるよう修正。
    openWorkEditModal: function(){
      // 確定済みならモーダルを開かない
      if(!(this.isViewOnly) && !(this.isOutsideTerm) && !(this.isTransferSalary)){
        this.$refs.WorkEditModal.openModal();
      }
    },
    // 区分コードに合わせた区分名を返す
    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.WORK_SEGMENT;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      return result;
    },
    // リスト情報を取得する
    getWorkRegistInfo: function(){
      this.getWorkRegistInfoFromAPI();
    },
    // APIから画面に表示する一覧を取得する
    getWorkRegistInfoFromAPI: function(){
      let paramList = {
          shainCd: this.loginUserId,
          targetDate: this.targetDate
      }
      console.debug(JSON.stringify(paramList));
      this.getWithParams(config.URL.WORK_REGIST, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.isErrorGetShfitFlg = false;
            this.setWorkRegistInfo(response.container);
          }
          else{
            this.isErrorGetShfitFlg = true;
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    // JSON形式で取得した情報をセットする
    setWorkRegistInfo: function(items){
      console.debug("items：" + JSON.stringify(items));
      this.dispDate = items.targetDate;
      this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
      let replaceTargetDate = items.targetDate.replace(/[^0-9]/g, '');
      this.targetDate = replaceTargetDate;
      this.dateType = items.dateType;
      this.dateTypeCode = items.dateTypeCode;
      this.shiftStart = items.shiftStart;
      this.shiftEnd = items.shiftEnd;
      this.todayWorkInfo = items.workInfoList;
      this.submittedFlag = items.submittedFlag;
      if(items.workInfoList != null && items.workInfoList.length > 0){
        this.afterStart = items.workInfoList[0].startTime;
        this.beforeEnd = items.workInfoList[items.workInfoList.length - 1].endTime;
      }
      else{
        this.afterStart = "";
        this.beforeEnd = "";
      }
      this.isViewOnly = items.dailyreportConfirmedFlg;
      this.isOutsideTerm = items.dailyreportOutsideTerm;
      this.isTransferSalary = items.sendedToPayrollSystemFlg;
      this.isNeedWorkApproval = items.needWorkApproval;
      this.workApprovalKbn = items.workApprovalKbn;
      this.approvalShainName = items.approvalShainName;
    },
    // 確定ボタン
    sendWorkMail: function(){
      let paramList = {
          shainCd: this.loginUserId,
          workDate: this.targetDate,
      }
      console.debug("paramList：" + JSON.stringify(paramList));
      let message = this.getStrDateSlash(this.targetDate) + "(" + this.getDayOfWeek(this.targetDate) + ")"
      + "の報告を確定します。"
      + "<br>よろしいですか？"
      this.$confirm(message, "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        dangerouslyUseHTMLString: true,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {
      this.getDataList(config.URL.SEND_MAIL_WORK_INFO, paramList)
        .then((response) => {
          console.debug("response：" + JSON.stringify(response));
          // this.showAlertUpdateSuccess("メールを送信しました。", "メール送信");
          if(!response.result){
            this.showAlertError(response.message);
          }
          else{
            this.getWorkRegistInfo();
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
      });
    },
    // 前日コピーボタン押下時の動作
    clickPreDateCopy: function(){
      if(this.isErrorGetShfitFlg){
        return;
      }
      this.getPreDateInfoFromAPI();
    },
    // APIから前日コピー処理をする
    getPreDateInfoFromAPI: function(){
      let paramList = {
          shainCd: this.loginUserId,
          workDate: this.targetDate,
      }
      console.debug(JSON.stringify(paramList));
      this.getDataList(config.URL.COPY_LAST_DAY, paramList)
        .then((response) => {
          console.debug("response：" + JSON.stringify(response.container));
          // responseはtrueかfalseのみ。trueなら画面を再描画
          if(response != null && response.result){
            this.getWorkRegistInfo();
            this.showToastSuccess(response.container,"");
          }
          else{
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    // 出勤しているかチェックする
    // true：出勤
    // false：休み
    isAttendanceCheck: function(workSegment){
      const WORK_SEGMENT_ATTENDANCE = 1; // 出勤
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
      const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12; // 休日出勤（残業）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 公休出勤（残業）
      
      if(workSegment != WORK_SEGMENT_ATTENDANCE
       && workSegment != WORK_SEGMENT_HOLIDAY_TRANSFER 
       && workSegment != WORK_SEGMENT_HOLIDAY_ALLOWANCE 
       && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER 
       && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE 
       && workSegment > 0){
        return false;
      }
      else{
        return true;
      }
    },
    // 確定解除ボタン押下時の動作
    clickCancelConfirm: function(){
      let paramList = {
          shainCd: this.loginUserId, // 社員コード
          targetDate: this.targetDate, // 対象日付
      }
      console.debug("paramList：" + JSON.stringify(paramList));
      let message = this.getStrDateSlash(this.targetDate) + "(" + this.getDayOfWeek(this.targetDate) + ")"
      + "の報告の確定を解除します。"
      + "<br>よろしいですか？"
      this.$confirm(message, "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        dangerouslyUseHTMLString: true,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {
      this.getWithParams(config.URL.SEND_MAIL_WORK_INFO_UNLOCK, paramList) 
        .then((response) => {
          console.debug("response：" + JSON.stringify(response));
          if(!response.result){
            this.showAlertError(response.message);
          }
          else{
            this.getWorkRegistInfo();
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
      });
    },
    // 事由 改行コードを<br>にする
    setLineFeedCode: function(msg){
      let newMsg = msg?.replace(/\n/g,'<br>');
      return newMsg;
    },
    isNotValidRegistBtn:function(){
      return this.workApprovalKbn == 4
    },
    // 休日区分は平日か？
    isDateTypeWeekday: function(datetype){
      if(datetype == config.VALUE.DATE_TYPE_WEEKDAY){
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>
<style>
/* 日時表示エリア */
.WorkRegist_DispDateArea {
  font-size: 1rem;
  width: 100%;
  text-align: center;
  background: #ececec;
  border-bottom: 1px solid rgb(241, 241, 241);
  padding: 0.3rem;
  padding-right: 1rem;
  padding-left: 1rem;
  font-size: 1.2rem;
}
.workCalendarIcon {
  position: absolute;
  right:0px;
}
/* シフト表示 */
.DispShiftArea {
  font-size: 0.9rem;
  padding: 0.3rem;
  width: 100%;
  text-align: center;
  background: #f8f8f8;
}
/* 事由表示欄 */
.WorkRegist_DispMemoArea {
  word-break: break-all;
}

.WorkM_AddButton {
  width: 100%;
  padding: 0.4rem !important;
  text-align: center;
  background: rgb(253, 253, 253);
  border: 1px solid rgb(216, 216, 216);
  color: rgb(83, 83, 83);
  border-radius: 5px;
  margin: 1rem 0;
  font-weight: 700;
}

.WorkM_PreCopyButton{
  width: auto !important;
}

.WorkM_WorkRegistButtonArea {
  display: flex;
  justify-content: center;
}

.WorkM_Button_Confirm{
  background-color: gray !important;
}
</style>
